import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { remapEditServicesToVenueCatalog } from '../../../../store/slices/bookingCreationSlice';

/**
 * Shared edit-page wiring for switching the venue/apartment of a booking:
 * call markPendingRemap() in the asset select's onChange (instead of wiping
 * the add-on selection), and once the new asset's service catalog has loaded
 * the selection is re-matched by service name (service rows are per asset).
 * Unavailable add-ons land in servicesUnavailableAtVenue for display.
 */
export function useEditServiceRemapOnAssetSwitch() {
    const dispatch = useDispatch();
    const selectedApartmentDetails = useSelector(
        (state: RootState) => state.bookingCreation.selectedEditApartmentDetails,
    );
    const servicesUnavailableAtVenue = useSelector(
        (state: RootState) => state.bookingCreation.editServicesUnavailableAtVenue,
    );
    const pendingRemapRef = useRef(false);

    useEffect(() => {
        if (pendingRemapRef.current && selectedApartmentDetails) {
            pendingRemapRef.current = false;
            dispatch(
                remapEditServicesToVenueCatalog({
                    catalog: selectedApartmentDetails.assetAdditionalServices ?? [],
                }),
            );
        }
    }, [selectedApartmentDetails, dispatch]);

    const markPendingRemap = useCallback(() => {
        pendingRemapRef.current = true;
    }, []);

    return { servicesUnavailableAtVenue, markPendingRemap };
}
